import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { Button } from '@app/components/core/button/Button'

export const LoadMoreCommentsButton = ({
  label,
  onClick,
}: {
  label: string
  onClick: () => void
}) => {
  return (
    <Button
      variant="link"
      onClick={onClick}
      icon={faPlus}
      iconPosition="left"
      label={label}
      style={{ alignSelf: 'start' }}
    />
  )
}
